import { LitElement, html, css } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { JobindsatsElement } from '../core/jobindsats-element';

@customElement('ji-callout-element')
export class JobindsatsCalloutElement extends JobindsatsElement(LitElement) {
    static styles = css`
        .callout-triangle {
	        width: 0;
            margin-bottom: -1px;
            margin-left: 40px;
            z-index: 101;
	        height: 0;
	        border-left: 15px solid transparent;
	        border-right: 15px solid transparent;
	        border-bottom: 15px solid var(--main-gray-50);
        }
        .callout-triangle-inner {
            width: 0;
            position: relative;
	        height: 0;
            left: -14px;
            top: 1px;
	        border-left: 14px solid transparent;
	        border-right: 14px solid transparent;
	        border-bottom: 14px solid white;
        }
        .pivot-triangle {
            margin-left: 160px;
        }
        .export-triangle {
            margin-left: 280px;
        }
        .callout-container {
            position: absolute;
            z-index: 1003;
            left: 0;
            margin-top: 55px;
            margin-left: calc(2*var(--column-spacing));
        }
        .export-container {
            margin-left: calc(2*var(--column-spacing));
        }
        .callout {
            background-color: white;
            border: 1px solid var(--main-gray-50);
            padding: 20px;
            overflow: auto;
        }

        @media only screen and (max-width: 991px) {
            .callout-container {
                margin-left: 0px;
                width: 100%;
            }
            .callout-triangle {
                margin-left: 65px;
            }
            .pivot-triangle {
                margin-left: 185px;
            }
            .export-triangle {
                margin-left: 305px;
            }
        }
        @media only screen and (max-width: 400px) {
            .callout-triangle {
                visibility: hidden;
            }
            .callout-triangle-inner {
                visibility: hidden;
            }
        }

    `;


    @property()
    targetSelector?: string;

    @property()
    exportBtn?: boolean = false;

    @property()
    pivotBtn?: boolean = false;

    render() {
        return html`
            <div class="callout-container ${this.exportBtn ? 'export-container' : ''} ${this.pivotBtn ? 'pivot-container' : ''}">
                <div class="callout-triangle ${this.exportBtn ? 'export-triangle' : ''} ${this.pivotBtn ? 'pivot-triangle' : ''}"><div class="callout-triangle-inner"></div></div>
                <div class="callout">
                    <slot></slot>
                </div>
        </div>
        `;
    }

    tabSelected(optionKey: string) {
        const tabSelectedEvent = new CustomEvent('tab-selected', {
            detail: {
                key: optionKey,
            },
            composed: true,
            bubbles: true,
        });
        this.dispatchEvent(tabSelectedEvent);
    }
}